/**
 * Set focus on first input having ng-invalid class
 */
export function focusFormError(): void {
  const errors = document.querySelectorAll('input.ng-invalid');
  const target = errors[0] as HTMLInputElement;
  target?.focus();
}
